<template>
  <div class="home-page">
    <div class="hero-section">
      <h1 class="markjy-title">MARKJY</h1>
      <p class="subtitle">{{ $t('site_subtitle') }}</p>
      <p class="tagline">{{ $t('site_tagline') }}</p>
      <div class="nav-links">
        <router-link to="/blog" class="nav-link">{{ $t('blog') }}</router-link>
        <span class="nav-sep">/</span>
        <router-link to="/about" class="nav-link">{{ $t('about') }}</router-link>
        <span class="nav-sep">/</span>
        <router-link to="/contact" class="nav-link">{{ $t('contact') }}</router-link>
      </div>
    </div>
    <footer class="site-footer">
      <p class="text-tertiary text-xs">&copy; {{ year }} MARKJY</p>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'Home',
  computed: {
    year() {
      return new Date().getFullYear()
    }
  }
}
</script>

<style scoped>
.home-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
.hero-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 92vh;
  padding: 40px 24px;
  text-align: center;
}
.markjy-title {
  font-size: 5rem;
  letter-spacing: 0.08em;
  margin-bottom: 12px;
}
.subtitle {
  font-size: 1.4rem;
  color: var(--text-secondary);
  margin-bottom: 4px;
}
.tagline {
  font-size: 1rem;
  color: var(--text-tertiary);
  margin-bottom: 32px;
}
.nav-links {
  display: flex;
  align-items: center;
  gap: 14px;
}
.nav-link {
  font-size: 0.95rem;
  color: var(--text-secondary);
  transition: color 0.2s ease;
  letter-spacing: 0.03em;
}
.nav-link:hover {
  color: var(--text-primary);
}
.nav-sep {
  color: var(--text-tertiary);
  font-size: 0.9rem;
}
.site-footer {
  text-align: center;
  padding: 24px;
}

@media (max-width: 640px) {
  .markjy-title {
    font-size: 3.2rem;
  }
  .subtitle {
    font-size: 1.15rem;
  }
}
</style>
